import { RESET_STATE } from 'store/global/actions';

import { PROGRAM_CATALOG_ACTION_TYPE } from '../actions';

const initialState = { data: [], isLoading: false, errorMessage: null };

const programCatalogReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PROGRAM_CATALOG_ACTION_TYPE.SET_PROGRAM_CATALOG_LOADING:
      return { ...state, isLoading: payload, errorMessage: payload ? null : state.errorMessage };

    case PROGRAM_CATALOG_ACTION_TYPE.GET_PROGRAM_CATALOG:
      return { data: payload ?? [], isLoading: false, errorMessage: null };

    case PROGRAM_CATALOG_ACTION_TYPE.SET_PROGRAM_CATALOG_ERROR:
      return { ...state, isLoading: false, errorMessage: payload ?? null };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default programCatalogReducer;
